import { render, staticRenderFns } from "./KajianMedis.vue?vue&type=template&id=8f37bb00&"
import script from "./KajianMedis.vue?vue&type=script&lang=js&"
export * from "./KajianMedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports